export default {
  order_again: 'Pedir de nuevo',
  error_messages: {
    product_does_not_exist: 'El producto ya no está disponible',
  },
  success_messages: {
    product_added_to_card: 'Producto añadido al carrito',
  },
};
